import React from "react";
import {connect} from "react-redux";
import {Button, Col, Collapse, Form, Input, message, Modal, Row, Select, Space, Steps} from "antd";
import {loadAllDomains} from "../../actions/domains";
import {displayErrors} from "../../libs/utils";
import {addContentWriterProject} from "../../actions/content_writer";
import PersonaGeneratorModal from "./PersonaGeneratorModal";

class AddContentWriterProjectModal extends React.Component {
    state = {
        loading: false,
        name: '',
        domain: '',
        domainList: [],
        loadingDomains: false,
        domainsLoaded: false,
        tagsList: [],
        step: 1,

        showPersonaGeneratorModal: false,
        persona_name: '',
        persona_history: '',
        persona_writing_style: '',
        persona_voice_tone: '',
        persona_target_audience: '',
        persona_personal_values: '',
        persona_example_phrases: '',
        persona_personality: ''
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.showModal && this.props.showModal && !this.state.domainsLoaded) {
            this.props.loadAllDomains(1, 9999, (res) => {
                let domains = res.data.data.map((domain) => {
                    return { label: domain.domain, value: domain.guid };
                });

                this.setState({ domainList: domains, loadingDomains: false, domainsLoaded: true });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingDomains: false, domainsLoaded: true });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    closeModal(reload = false) {
        this.setState({
            loading: false,
            name: '',
            domain: '',
            domainList: [],
            loadingDomains: false,
            domainsLoaded: false,
            tagsList: [],
            step: 1,

            showPersonaGeneratorModal: false,
            persona_name: '',
            persona_history: '',
            persona_writing_style: '',
            persona_voice_tone: '',
            persona_target_audience: '',
            persona_personal_values: '',
            persona_example_phrases: '',
            persona_personality: ''
        }, () => this.props.close(reload));
    }

    addProject() {
        if(this.state.name.trim().length === 0) {
            return message.error('Please enter the project name!');
        }

        if(this.state.domain.trim().length === 0) {
            return message.error('Please select a domain!');
        }

        let data = {
            name: this.state.name.trim(),
            domain: this.state.domain,
            tags: this.state.tagsList,
            persona_name: this.state.persona_name,
            persona_history: this.state.persona_history,
            persona_writing_style: this.state.persona_writing_style,
            persona_voice_tone: this.state.persona_voice_tone,
            persona_target_audience: this.state.persona_target_audience,
            persona_personal_values: this.state.persona_personal_values,
            persona_example_phrases: this.state.persona_example_phrases,
            persona_personality: this.state.persona_personality,
        };

        this.setState({ loading: true });

        this.props.addContentWriterProject(data, (res) => {
            message.success('Project added successfully!');
            this.props.history.push('/content/' + res.data.guid);
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    nextStep() {
        if(this.state.step === 1) {
            if(this.state.name.trim().length === 0) {
                return message.error('Please enter the project name!');
            }

            if(this.state.domain.trim().length === 0) {
                return message.error('Please select a domain!');
            }
        }

        this.setState({ step: this.state.step + 1 });
    }

    previousStep() {
        this.setState({ step: this.state.step - 1 });
    }


    render() {
        const { TextArea } = Input;
        const { Panel } = Collapse;

        const step1 = <Form layout='vertical'>
            <Form.Item label='Name'>
                <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
            </Form.Item>
            <Form.Item label='Domain'>
                <Select
                    options={this.state.domainList}
                    loading={this.state.loadingDomains}
                    showSearch allowClear notFoundContent={<span>No domains found!</span>}
                    onChange={(value) => this.setState({ domain: value })}
                    filterOption={(input, option) => {
                        if(typeof option !== 'undefined') {
                            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }
                        return false;
                    }} />
            </Form.Item>
            <Form.Item label='Tags'>
                <Select
                    mode='tags' allowClear value={this.state.tagsList}
                    onChange={(values) => this.setState({ tagsList: values })}/>
            </Form.Item>
        </Form>;

        const step2 = <Row>
            <Col span={24}>
                <Form layout='vertical'>
                    <Form.Item label={<span>Persona's name</span>}>
                        <Input value={this.state.persona_name} onChange={(e) => this.setState({ persona_name: e.target.value })} />
                    </Form.Item>
                </Form>
                <p>The fields below are optional, but we strongly recommend filling them out to keep your content unique and consistent in style.</p>
                <Collapse>
                    <Panel header='Personality' key='personality'>
                        <TextArea value={this.state.persona_personality} rows={3} onChange={(e) => this.setState({ persona_personality: e.target.value })}/>
                        <small>The personality of the persona. The personality shapes the content the persona writes.</small>
                    </Panel>
                    <Panel header='History' key='history'>
                        <TextArea value={this.state.persona_history} rows={3}
                                  onChange={(e) => this.setState({persona_history: e.target.value})}/>
                        <small>History of the persona. Short background info about the persona.</small>
                    </Panel>
                    <Panel header='Personal values' key='personal-values'>
                        <TextArea value={this.state.persona_personal_values} rows={3}
                                  onChange={(e) => this.setState({persona_personal_values: e.target.value})}/>
                        <small>The personal values of the persona. Personal values describe what the persona believes in.</small>
                    </Panel>
                    <Panel header='Writing style' key='writing-style'>
                        <TextArea value={this.state.persona_writing_style} rows={3}
                                  onChange={(e) => this.setState({persona_writing_style: e.target.value})}/>
                        <small>The writing style of the persona.</small>
                    </Panel>
                    <Panel header='Voice & tone' key='voice-tone'>
                        <TextArea value={this.state.persona_voice_tone} rows={3}
                                  onChange={(e) => this.setState({persona_voice_tone: e.target.value})}/>
                        <small>The voice and tone of the persona. Voice and tone set how the persona writes.</small>
                    </Panel>
                    <Panel header='Example phrases' key='example-phrases'>
                        <TextArea value={this.state.persona_example_phrases} rows={3}
                                  onChange={(e) => this.setState({persona_example_phrases: e.target.value})}/>
                        <small>Example phrases of the persona. These are phrases that the persona likes to use often.</small>
                    </Panel>
                    <Panel header='Target audience' key='target-audience'>
                        <TextArea value={this.state.persona_target_audience} rows={3}
                                  onChange={(e) => this.setState({persona_target_audience: e.target.value})}/>
                        <small>The target audience of the persona. To who this persona writes to.</small>
                    </Panel>
                </Collapse>
            </Col>
        </Row>;

        const steps = [
            { title: 'Settings' },
            { title: 'Persona' },
        ];

        return <>
            <Modal
                centered
                title='Add Project'
                open={this.props.showModal}
                destroyOnClose={true}
                footer={<Row justify='space-between'>
                    <Col>
                        <Button onClick={() => this.closeModal()}>Close</Button>
                    </Col>
                    <Col>
                        {this.state.step === 1 ? <Button type='primary' onClick={() => this.nextStep()}>Next</Button> : ''}
                        {this.state.step === 2 ? <Space>
                            <Button onClick={() => this.previousStep()}>Previous</Button>
                            <Button onClick={() => this.setState({ showPersonaGeneratorModal: true })}>Generate Persona</Button>
                            <Button type='primary' onClick={() => this.addProject()} disabled={this.state.loading} loading={this.state.loading}>Add Project</Button>
                        </Space> : ''}
                    </Col>
                </Row>}
                onCancel={() => this.closeModal()}>
                <Steps size='small' current={this.state.step-1} items={steps} />
                <br />
                {this.state.step === 1 ? step1 : ''}
                {this.state.step === 2 ? step2 : ''}
            </Modal>

            <PersonaGeneratorModal
                showModal={this.state.showPersonaGeneratorModal}
                close={() => this.setState({ showPersonaGeneratorModal: false })}
                updateData={(data) => this.setState({
                    persona_name: data.name,
                    persona_history: data.history,
                    persona_writing_style: data.writing_style,
                    persona_voice_tone: data.voice_tone,
                    persona_target_audience: data.target_audience,
                    persona_personal_values: data.personal_values,
                    persona_example_phrases: data.example_phrases,
                    persona_personality: data.personality
                })}
            />
        </>;
    }
}

export default connect(null, { loadAllDomains, addContentWriterProject })(AddContentWriterProjectModal);